import { useState } from "react";
import { withSpan } from "./otel";
import { signIn } from "./session";
import { demote, impersonateLink, promote, type AdminUser } from "./users";

type Phase = { name: "idle" } | { name: "busy" } | { name: "error"; message: string };

export function UserRow({
  user,
  showImpersonate,
  onUpdated,
}: {
  user: AdminUser;
  showImpersonate: boolean;
  onUpdated: (user: AdminUser) => void;
}) {
  const [phase, setPhase] = useState<Phase>({ name: "idle" });

  async function toggleRole() {
    const action = user.role === "admin" ? demote : promote;
    const spanName = user.role === "admin" ? "users.demote" : "users.promote";

    setPhase({ name: "busy" });
    const result = await withSpan(spanName, { "users.sub": user.sub }, () => action(user.sub));

    if (result.kind === "ok") {
      setPhase({ name: "idle" });
      onUpdated({ ...user, role: result.value.role as "customer" | "admin" });
    } else if (result.kind === "unauthorized") {
      signIn(window.location.pathname);
    } else {
      setPhase({ name: "error", message: result.message });
    }
  }

  async function impersonate() {
    setPhase({ name: "busy" });
    const result = await withSpan("users.impersonate", { "users.sub": user.sub }, () => impersonateLink(user.sub));

    if (result.kind === "ok") {
      setPhase({ name: "idle" });
      window.location.assign(result.value);
    } else if (result.kind === "unauthorized") {
      signIn(window.location.pathname);
    } else {
      setPhase({ name: "error", message: result.message });
    }
  }

  return (
    <tr>
      <td>
        <code>{user.sub}</code>
      </td>
      <td>{user.name ?? "—"}</td>
      <td>{user.email ?? "—"}</td>
      <td>
        <span className={`role-badge ${user.role}`}>{user.role}</span>
      </td>
      <td>
        <button type="button" onClick={toggleRole} disabled={phase.name === "busy"}>
          {phase.name === "busy" ? "…" : user.role === "admin" ? "Demote" : "Promote"}
        </button>
        {showImpersonate && (
          <button type="button" onClick={impersonate} disabled={phase.name === "busy"}>
            Impersonate
          </button>
        )}
        {phase.name === "error" && <p className="field-error">{phase.message}</p>}
      </td>
    </tr>
  );
}
